import styled, { css } from 'styled-components';
import { StyledAxisProps } from './types';
import { animated } from '@react-spring/web';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledAxis = styled(animated.g)<StyledAxisProps>`
  .redsift-axis__line,
  .redsift-axis-tick__line {
    fill: none;
    ${({ $theme }) => css`
      stroke: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    `}
    shape-rendering: crispEdges;
  }

  text {
    font-family: var(--redsift-typography-font-family-poppins);
    ${({ $theme }) => css`
      fill: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    `}
    font-size: 10px;
    user-select: none;
  }

  text.colored {
    ${({ $theme, $color }) => css`
      fill: ${$color === 'green'
        ? '#029B57'
        : $color === 'red'
        ? '#CB0E0E'
        : `var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'})`};
    `}
  }
`;
